<template>
  <div id="app">
    <router-view/>
    <Loading/>
  </div>
</template>

<script>
import Arecord from '@/views/kiwoom/usRecord/pc/Arecord'
import Brecord from '@/views/kiwoom/usRecord/pc/Brecord'
import Crecord from '@/views/kiwoom/usRecord/pc/Crecord'
import Drecord from '@/views/kiwoom/usRecord/pc/Drecord'
import Erecord from '@/views/kiwoom/usRecord/pc/Erecord'
import MbArecord from '@/views/kiwoom/usRecord/mb/Arecord'
import MbBrecord from '@/views/kiwoom/usRecord/mb/Brecord'
import MbCrecord from '@/views/kiwoom/usRecord/mb/Crecord'
import MbDrecord from '@/views/kiwoom/usRecord/mb/Drecord'
import MbErecord from '@/views/kiwoom/usRecord/mb/Erecord'
import Loading from '@/components/common/Loading'

export default {
  components: {
    Arecord,
    Brecord,
    Crecord,
    Drecord,
    Erecord,
    MbArecord,
    MbBrecord,
    MbCrecord,
    MbDrecord,
    MbErecord,
    Loading
  },
  data: () => ({
  }),
  watch: {
    '$route' () {
      // google analytics
      window['GoogleAnalyticsObject'] = 'ga'
      window['ga'] = window['ga'] || function () {
        (window['ga'].q = window['ga'].q || []).push(arguments)
      }
      // console.log(this.$route.fullPath)
      ga('set', 'page', this.$route.fullPath) // traking set
      ga('send', 'pageview'); // page traking
      // wiselog
      (function () {
        n_logging()
      })()
    }
  },
  created () {
    // google analytics
    window['GoogleAnalyticsObject'] = 'ga'
    window['ga'] = window['ga'] || function () {
      (window['ga'].q = window['ga'].q || []).push(arguments)
    }
    ga('set', 'page', this.$route.fullPath) // traking set
    ga('send', 'pageview') // page traking
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue